var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "人员成本详情",
        visible: _vm.dialogVisible,
        width: "860px",
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _vm.header
            ? _c("div", { staticClass: "header-info" }, [
                _c("span", [_vm._v("岗位：" + _vm._s(_vm.header.stationName))]),
                _c("span", [
                  _vm._v(
                    "人员：" + _vm._s(_vm.header.userName || _vm.header.userId)
                  )
                ]),
                _c("span", [
                  _vm._v(
                    "总成本：" + _vm._s(_vm.formatAmount(_vm.header.totalCost))
                  )
                ])
              ])
            : _vm._e(),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.items,
                border: "",
                size: "small",
                "max-height": "420",
                "empty-text": "暂无成本明细"
              }
            },
            [
              _c("el-table-column", {
                attrs: { label: "成本类型", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.costTypeLabel(scope.row.costType)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "金额", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatAmount(scope.row.amount)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "备注",
                  "min-width": "180",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessMonth",
                  label: "业务月份",
                  width: "100"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "按月累加", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.autoMonthly === "1" ? "是" : "否")
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatDate(scope.row.dateCreated)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.isManualItem(scope.row)
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit(
                                      "edit-item",
                                      scope.row,
                                      _vm.header
                                    )
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            )
                          : _c("span", [_vm._v("-")])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("关闭")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }